import React, { useEffect, useState } from "react";
import { ToastMessage } from "../../../global/ToastMessage";
import { FPaquetesStyle } from "./styles";
import useCatalogo from "./../../../hooks/useCatalogos";
import { useFormik, getIn } from "formik";
import TextField from "@material-ui/core/TextField";
import {
  Button,
  Grid,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  InputAdornment
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import {
  altaPaqueteBaseAction,
  actulizarPaqueteAction,
  obtenerPaquetebyIdAction,
} from "./../../../ducks/paqueteDuck";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import HeaderModal from "../../../global/headerModal";
import useApi from "./../../../hooks/useAPI";
import BackDrop from "./../../../global/BackDrop";
import ModalBase from "./../../../global/ModalBase";
import * as yup from "yup";

const validationSchema = yup.object({
  nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  descripcion: yup
    .string("Ingresa una descripción")
    .min(15, "Minimo 15 caracteres")
    .max(150, "Maximo 150 caracteres")
    .required("Descripcion es requerido"),
  impuesto: yup
    .number("Ingresa numeros")
    .required("Impuesto es requerido"),
  tcPrevisto: yup.number("Ingresa numeros").required("Tarifa es requerido"),
  tarifa: yup.number("Ingresa numeros").required("Tarifa es requerido"),
  dias: yup.number("Ingresa numeros").required("Dias es requerido"),
  noches: yup.number("Ingresa numeros").required("Noches es requerido"),
  numeroPersonas: yup
    .number("Ingresa numeros")
    .required("Numero de personas es requerido"),
});

const InitalValues = {
  nombre: "",
  precioNeto: 0,
  precioPublico: 0,
  impuesto: 0,
  tarifa: 0,
  descripcion: "",
  noches: 1,
  dias: 2,
  numeroPersonas: "",
  oldIdGrupoPaquete: 0,
  tcPrevisto: 1
};

const FPaqutes = (props) => {
  const {
    open = true,
    setOpen = () => { },
    rowData = {},
    editar = false,
    setEditar = () => { },
  } = props;

  const dispatch = useDispatch();
  const classes = FPaquetesStyle();
  const catalogoTipoViaje = useCatalogo("TipoViaje");
  const catalogoTipoMoneda = useCatalogo("MonedaProveedor");
  const catalogoProveedores = useApi("Supplier/wholesaler");
  const [tipoPaquete, setTipoPaquete] = useState([]);
  const [IdProveedor, setIdProveedor] = useState(0);
  const [tipoMoneda, setTipoMoneda] = useState(0);
  const [monedaProveedor, setMonedaProveedor] = useState(0)
  const [descMoneda, setDescMoneda] = useState("");
  const catalogoGrupoPaquete = useApi(`Supplier/groupPack/${IdProveedor}`);
  const [idGrupoPaquete, setIdGrupoPaquete] = useState(0);
  const [isLoad, setIsLoad] = useState(false);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const formik = useFormik({
    initialValues: InitalValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (IdProveedor > 0 && tipoPaquete.length > 0 && idGrupoPaquete > 0) {
        let Paquete = {
          Nombre: values.nombre,
          Descripcion: values.descripcion,
          IdProveedorGrupoPaquete: idGrupoPaquete,
          Tarifa: Number(values.tarifa),
          Impuesto: Number(values.impuesto),
          TiposPaquete: getIdTipoPaquete(tipoPaquete),
          IdMoneda: tipoMoneda,
          Dias: Number(values.dias),
          Noches: values.noches,
          Personas: Number(values.numeroPersonas),
          TipoCambioPrevisto: monedaProveedor === 1 ? 1 : values.tcPrevisto,
          IdMonedaPagoProveedor: monedaProveedor,
          oldIdProveedorGrupoPauqete: (idGrupoPaquete !== values.oldIdGrupoPaquete) ? values.oldIdGrupoPaquete : 0
        };
        (!editar) ? onNewPaquete(Paquete) : onUpdatePaquete(Paquete);
      }
    },
  });

  const onUpdatePaquete = (Paquete) => {
    setIsLoad(true);
    dispatch(actulizarPaqueteAction(rowData.IdPaquete, Paquete)).then(
      (Response) => {
        switch (Response.status) {
          case 500:
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema de conexión con el servidor",
            });
            break;
          case 400:
            ToastMessage.fire({
              icon: "warning",
              title: "<strong>Atención</strong>",
              text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
            });
            break;
          default:
            handleClose();
            ToastMessage.fire({
              icon: "success",
              title: "Ingreso Correcto",
            });
            break;
        }
        setIsLoad(false);
      }
    );
  }
  const onNewPaquete = (Paquete) => {
    setIsLoad(true);
    dispatch(altaPaqueteBaseAction(Paquete)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break;
      }
      setIsLoad(false);
    });
  }

  const valDias = getIn(formik.values, "dias");

  useEffect(() => {
    if (valDias && valDias > 0) {
      formik.setFieldValue("noches", valDias - 1);
    } else {
      formik.setFieldValue("noches", 0);
    }
  }, [valDias]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const buscarById = () => {
      setIsLoad(true);
      dispatch(obtenerPaquetebyIdAction(rowData.IdPaquete)).then((Response) => {
        formik.setFieldValue("descripcion", Response.Descripcion)
        formik.setFieldValue("nombre", Response.Nombre)
        formik.setFieldValue("impuesto", Response.Impuesto)
        formik.setFieldValue("tarifa", Response.Tarifa)
        formik.setFieldValue("precioNeto", Response.PrecioNeto)
        formik.setFieldValue("precioPublico", Response.PrecioPublico)
        formik.setFieldValue("dias", Response.Dias)
        formik.setFieldValue("noches", Response.Noches)
        formik.setFieldValue("numeroPersonas", Response.Personas)
        formik.setFieldValue("tcPrevisto", Response.TipoCambioPrevisto)
        if (Response.Moneda) {
          setTipoMoneda(Response.Moneda.id_moneda);
          setDescMoneda((Response.Moneda.Clave));
        }
        if (Response.MonedaPagoProveedor) {
          setMonedaProveedor(Response.MonedaPagoProveedor.id_moneda)
        }

        if (Response.grupoPaqueteProveedor) {
          formik.setFieldValue("oldIdGrupoPaquete", Response.grupoPaqueteProveedor.IdProveedorGrupoPaquete)
          setIdProveedor(Response.grupoPaqueteProveedor.IdProveedor);
          setIdGrupoPaquete(Response.grupoPaqueteProveedor.IdProveedorGrupoPaquete);
        }
        if (Response.TipoPaquete)
          if (Response.TipoPaquete[0] !== null)
            setTipoPaquete(Response.TipoPaquete);
        setIsLoad(false);
      });
    };
    if (editar) buscarById();
    return () => {
      LimpiarForm();
    }
  }, [editar, rowData.IdPaquete, dispatch]) // eslint-disable-line react-hooks/exhaustive-deps

  const LimpiarForm = () => {
    formik.resetForm(InitalValues)
    setIdProveedor(0)
    setTipoMoneda(0)
    setMonedaProveedor(0)
    setTipoPaquete([])
    setDescMoneda("")
    setIdGrupoPaquete(0)
  }
  const handleClose = () => {
    setOpen(!open)
    setEditar(false)
    LimpiarForm()
  }
  const handleSelecTipoMoneda = (event) => {
    setTipoMoneda(event.target.value);
    setDescMoneda(catalogoTipoMoneda.find(moneda => moneda.IdMoneda === event.target.value).Clave)
  }
  const handleSelecTipoMonedaProveedor = (event) => {
    formik.setFieldValue("tcPrevisto", 1)
    setMonedaProveedor(event.target.value)
  }
  const handleSelecProveedor = (event) => {
    setIdProveedor(event.target.value);
    setIdGrupoPaquete(0);
  }
  const handleChange = (event) => {
    const value = event.target.value;
    setTipoPaquete(value);
  }
  const getDescripcion = (arrayTipo) => {
    return arrayTipo.map((item) => {
      return item.Descripcion;
    })
  }
  const getIdTipoPaquete = (arrayTipo) => {
    return arrayTipo.map((item) => {
      return item.IdTipoViaje;
    })
  }
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        handleClose={handleClose}
        titulo={editar ? "Actuliza paquete" : "Nuevo paquete"}
      />
      <form onSubmit={formik.handleSubmit}>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={4}>
            <TextField
              required
              id="input-Nombre"
              label="Nombre"
              type="text"
              variant="outlined"
              name="nombre"
              value={formik.values.nombre}
              onChange={formik.handleChange}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={formik.touched.nombre && formik.errors.nombre}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="lTipoMonedaProveedor">Moneda pago proveedor</InputLabel>
              <Select
                labelId="lTipoMonedaProveedor"
                id="STipoMonedaProveedor"
                name="tipoMonedaProveedor"
                value={monedaProveedor}
                onChange={handleSelecTipoMonedaProveedor}
                label="Moneda pago proveedor"
              >
                <MenuItem value="0" disabled>
                  {"Seleccione una opción"}
                </MenuItem>
                {catalogoTipoMoneda.map((moneda, index) => (
                  <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                    {`${moneda.Clave} - ${moneda.Descripcion}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-tcTipoCambio"
              label="T.C. Previsto"
              type="text"
              variant="outlined"
              name="tcPrevisto"
              disabled={monedaProveedor === 1}
              value={formik.values.tcPrevisto}
              onChange={formik.handleChange}
              error={formik.touched.tcPrevisto && Boolean(formik.errors.tcPrevisto)}
              helperText={formik.touched.tcPrevisto && formik.errors.tcPrevisto}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="lTipoProveedor">Proveedor</InputLabel>
              <Select
                labelId="lTipoProveedor"
                id="STipoProveedor"
                name="proveedor"
                value={IdProveedor}
                onChange={handleSelecProveedor}
                label="Proveedor"
              >
                <MenuItem value="0" disabled>
                  {"Seleccione una opción"}
                </MenuItem>
                {catalogoProveedores.map((item, index) => (
                  <MenuItem key={item.IdProveedor} value={item.IdProveedor}>
                    {item.RazonSocial}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {
            catalogoGrupoPaquete.length > 0 &&
            <Grid item xs={4}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="lGrupoPaqueter">Grupo</InputLabel>
                <Select
                  labelId="lGrupoPaqueter"
                  id="SGrupoPaqueter"
                  name="proveedor"
                  value={idGrupoPaquete}
                  onChange={(e) => setIdGrupoPaquete(e.target.value)}
                  label="Grupo"
                >
                  <MenuItem value="0" disabled>
                    {"Seleccione una opción"}
                  </MenuItem>
                  {catalogoGrupoPaquete.map((item, index) => (
                    <MenuItem key={item.IdProveedorGrupoPaquete} value={item.IdProveedorGrupoPaquete}>
                      {item.grupoPaquete.Descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          }
          <Grid item xs={4}>
            <TextField
              required
              id="input-Numero-personas"
              label="Personas"
              type="text"
              variant="outlined"
              name="numeroPersonas"
              value={formik.values.numeroPersonas}
              onChange={formik.handleChange}
              error={
                formik.touched.numeroPersonas &&
                Boolean(formik.errors.numeroPersonas)
              }
              helperText={
                formik.touched.numeroPersonas && formik.errors.numeroPersonas
              }
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="lTipoMoneda">Moneda paquete</InputLabel>
              <Select
                labelId="lTipoMoneda"
                id="STipoMoneda"
                name="tipoMoneda"
                value={tipoMoneda}
                onChange={handleSelecTipoMoneda}
                label="Moneda paquete"
              >
                <MenuItem value="0" disabled>
                  {"Seleccione una opción"}
                </MenuItem>
                {catalogoTipoMoneda.map((moneda, index) => (
                  <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                    {`${moneda.Clave} - ${moneda.Descripcion}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="txtTarifa"
              label="Tarifa"
              type="text"
              variant="outlined"
              name="tarifa"
              value={formik.values.tarifa}
              onChange={formik.handleChange}
              error={
                formik.touched.tarifa && Boolean(formik.errors.tarifa)
              }
              helperText={formik.touched.tarifa && formik.errors.tarifa}
              className={classes.textField}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {descMoneda}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="txtImpuesto"
              label="Impuesto"
              type="text"
              variant="outlined"
              name="impuesto"
              value={formik.values.impuesto}
              onChange={formik.handleChange}
              error={
                formik.touched.impuesto &&
                Boolean(formik.errors.impuesto)
              }
              helperText={
                formik.touched.impuesto && formik.errors.impuesto
              }
              className={classes.textField}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {descMoneda}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          {
            (editar) &&
            <Grid item xs={4}>
              <TextField
                disabled
                id="txtPrecio"
                label="Precio neto"
                type="text"
                variant="outlined"
                name="precioNeto"
                value={formik.values.precioNeto}
                onChange={formik.handleChange}
                error={
                  formik.touched.precioNeto && Boolean(formik.errors.precioNeto)
                }
                helperText={formik.touched.precioNeto && formik.errors.precioNeto}
                className={classes.textField}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {descMoneda}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          }
          {
            (editar) && <Grid item xs={4}>
              <TextField
                disabled
                id="txtPrecio"
                label="Precio publico"
                type="text"
                variant="outlined"
                name="precioPublico"
                value={formik.values.precioPublico}
                onChange={formik.handleChange}
                error={
                  formik.touched.precioPublico &&
                  Boolean(formik.errors.precioPublico)
                }
                helperText={
                  formik.touched.precioPublico && formik.errors.precioPublico
                }
                className={classes.textField}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {descMoneda}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          }


          <Grid item xs={4}>
            <TextField
              required
              id="input-Dias"
              label="Dias"
              type="text"
              variant="outlined"
              name="dias"
              value={formik.values.dias}
              onChange={formik.handleChange}
              error={formik.touched.dias && Boolean(formik.errors.dias)}
              helperText={formik.touched.dias && formik.errors.dias}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-Noches"
              label="Noches"
              type="text"
              variant="outlined"
              name="noches"
              value={formik.values.noches}
              onChange={formik.handleChange}
              error={formik.touched.noches && Boolean(formik.errors.noches)}
              helperText={formik.touched.noches && formik.errors.noches}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-mutiple-checkbox-label">
                Tipo paquete
              </InputLabel>
              <Select
                labelId="demo-mutiple-checkbox-label"
                id="demo-mutiple-checkbox"
                multiple
                value={tipoPaquete}
                onChange={handleChange}
                input={<Select label="Tipo paquete" id="Select-multiple" />}
                renderValue={(selected) =>
                  new Intl.ListFormat('es').format(getDescripcion(selected))
                }
                MenuProps={MenuProps}
              >
                {catalogoTipoViaje.map((item) => (
                  <MenuItem key={item.IdTipoViaje} value={item}>
                    <Checkbox checked={tipoPaquete.find(tipo => tipo.IdTipoViaje === item.IdTipoViaje) ? true : false} />
                    <ListItemText primary={item.Descripcion} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12}>
            <TextField
              id="outlined-Descripcion-static"
              label="Descripción"
              multiline
              rows={5}
              variant="outlined"
              name="descripcion"
              value={formik.values.descripcion}
              onChange={formik.handleChange}
              error={
                formik.touched.descripcion && Boolean(formik.errors.descripcion)
              }
              helperText={
                formik.touched.descripcion && formik.errors.descripcion
              }
              className={classes.textFieldMultiLinea}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.modalBoton}
            >
              {editar ? "Actulizar" : "Guardar"}
            </Button>
          </Grid>
        </Grid>
        <BackDrop open={isLoad} />
      </form>
    </ModalBase>
  );
};
export default FPaqutes;
